import axios from "axios";
import FormData from "form-data";
import {
  clearAffiliateAuth,
  clearStudentAuth,
  normalizeStoredToken,
} from "./authSession";

const getToken = async () => {
    try {
        return normalizeStoredToken(localStorage.getItem("token"));
    } catch (error) {
        return null;
    }
};

class Api {
  constructor() {
    this.client = null;
    this.api_url =
      process.env.NODE_ENV === "development"
        ? "https://backend.kingster.edu.in/api"
        : `https://backend.kingster.edu.in/api`;
        
    // this.api_url = process.env.NODE_ENV === "development" ? "http://localhost:5000/api" : `http://localhost:5000/api`;
  }


  // console
  

  init = (type) => {
    let headers;

    headers = {
      Accept: "application/json",
    };

    if (type === "multipart/form-data") {
      headers = {
        "Content-Type": "multipart/form-data",
      };
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
    });

    this.client.interceptors.request.use(
      async (config) => {
        const token = await getToken();
        const affiliateToken = normalizeStoredToken(
          localStorage.getItem("affiliatetoken")
        );
        const bearer = token || affiliateToken;
        if (bearer) {
          config.headers["Authorization"] = `Bearer ${bearer}`;
        }
        return config;
      },
      (error) => {
        throw error;
      }
    );

    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;
        if (status === 401) {
          const token = normalizeStoredToken(localStorage.getItem("token"));
          const affiliateToken = normalizeStoredToken(
            localStorage.getItem("affiliatetoken")
          );
          if (token) {
            clearStudentAuth();
          } else if (affiliateToken) {
            clearAffiliateAuth();
          }
        }
        return Promise.reject(error);
      }
    );

    return this.client;
  };

  // affiliate
  registerAffiliate = (data) => {
    return this.init().post("/affiliate/auth/affiliate/register", data);
  };
  registerAffiliateWithGoogle = (data) => {
    return this.init().post(`/affiliate/auth/affiliate/googlesignup`, data);
  };

  verifyAffiliateUser = (data) => {
    return this.init().post("/affiliate/auth/affiliate/verify-affiliate", data);
  };

  AffiliatereSendOtp = (data) => {
    return this.init().post(`/affiliate/auth/re-send-otp`, data);
  };
  loginAffiliateWithGoogle = (data) => {
    return this.init().post(`/affiliate/auth/affiliate/googlr-login`, data);
  };
  AffiliateLogin = (data) => {
    return this.init().post("/affiliate/auth/affiliate/login", data);
  };
  AffiliateforgotPassword = (data) => {
    return this.init().post("/affiliate/auth/affiliate/forgotpassword", data);
  };
  AffiliateverifyOtp = (data) => {
    return this.init().post(
      "/affiliate/auth/affiliate/verify-forgotpassword",
      data
    );
  };
  AffiliateresetPassword = (data) => {
    return this.init().post("/affiliate/auth/affiliate/reset-password", data);
  };
  AffiliategetProfile = (data, config) => {
    return this.init().get("/affiliate/getprofile", data);
  };
  AffiliateupdateProfile = (data, config) => {
    return this.init().put("/affiliate/upadate-bio", data);
  };
  AffiliateconfirmUpdateProfile = (data) => {
    return this.init().put("/affiliate/verify/update-bio", data);
  };
  AffiliateupdatePassword = (data, config) => {
    return this.init().put("/affiliate/change-password", data);
  };
  deleteAffiliateAccount = () => {
    return this.init().delete("/affiliate/delete-account");
};
  generateLink = (data) => {
    return this.init().post("/affiliate/generateLink", data);
  };
  getCoursesAffiliate = () => {
    return this.init().get("/affiliate/get-Courses");
  };

// In your Api class - Fix the getWebinarsAffiliate method
getWebinarsAffiliate = () => {
  return this.init().get("/affiliate/get-Webinars");
};
  // login

  studentLogin = (data) => {
    return this.init().post("/student/auth/student/login", data);
  };
  forgotPassword = (data) => {
    return this.init().post("/student/auth/student/forgotpassword", data);
  };
  verifyOtp = (data) => {
    return this.init().post(
      "/student/auth/student/verify-forgotpassword",
      data
    );
  };
  resetPassword = (data) => {
    return this.init().post("/student/auth/student/reset-password", data);
  };
  getProfile = (data, config) => {
    return this.init().get("/student/getprofile", data);
  };
  updateProfile = (data, config) => {
    return this.init().put("/student/upadate-bio", data);
  };
  confirmUpdateProfile = (data) => {
    return this.init().put("/student/verify/update-bio", data);
  };

  updatePassword = (data, config) => {
    return this.init().put("/student/change-password", data);
  };
  fileUpload = (data, config) => {
    return this.init("multipart/form-data").post("/admin/upload-file", data);
  };
  registerStudent = (data) => {
    return this.init().post("/student/auth/student/register", data);
  };
  verifyRegisterStudent = (data) => {
    return this.init().post("/student/auth/student/verify-register", data);
  };
  verifyLoginOtp = (data) => {
    return this.init().post(
      "/student/auth/student/verify-login-otp",
      data
    );
  };
  resendOtp = (data) => {
    return this.init().post("/student/auth/re-send-otp", data);
  };
  initMasterclassAuth = (data) => {
    return this.init().post("/student/auth/masterclass/init", data);
  };
  verifyMasterclassOtp = (data) => {
    return this.init().post("/student/auth/masterclass/verify-otp", data);
  };
  registerMasterclassStudent = (data) => {
    return this.init().post("/student/auth/masterclass/register", data);
  };
  verifyMasterclassRegister = (data) => {
    return this.init().post("/student/auth/masterclass/verify-register", data);
  };
  resendMasterclassOtp = (data) => {
    return this.init().post("/student/auth/masterclass/resend-otp", data);
  };
  updateMasterclassWatchProgress = (data) => {
    return this.init().put("/student/course/masterclass-watch-progress", data);
  };
  registerWithGoogle = (data) => {
    return this.init().post(`/student/auth/student/googlesignup`, data);
  };
  loginWithGoogle = (data) => {
    return this.init().post(`/student/auth/student/googlr-login`, data);
  };
  getDashboardData = (data) => {
    return this.init().get("/student/course/dashboard", data);
  };
  getWishlistCourse = (data) => {
    return this.init().get(
      "/student/course/student/get-course-from-whishlist",
      data
    );
  };
  getPurchasedCourse = (data) => {
    return this.init().get(
      `/student/course/get-all-purchased-courses?${data}`,
      data
    );
  };

  getCatSubCategories = (data) => {
    return this.init().get("/student/auth/student/getallcategories", data);
  };
  getRating = (data) => {
    return this.init().get(
      "/student/auth/student/documentcountbyratings",
      data
    );
  };
  getCourseLevel = (data) => {
    return this.init().get("/student/auth/student/documentcountbylevel", data);
  };
  getPayment = (data) => {
    return this.init().get(
      "/student/auth/student/documentcountbypayment",
      data
    );
  };
  getDuration = (data) => {
    return this.init().get(
      "/student/auth/student/documentcountbyduration",
      data
    );
  };
  getAllCourses = (data) => {
    return this.init().get(`/student/auth/student/getcourses?${data}`);
  };
  getCourseDetails = (data) => {
    return this.init().get(`/student/auth/student/getcourse/${data}`);
  };
  getCourseDetailsByCategory = (data) => {
    return this.init().post(`/student/auth/student/getcoursebycategory`, data);
  };
  getSearchSuggession = (query) => {
    return this.init().get(`/student/course/suggestions?searchString=${query}`);
  };
  getCourseCount = (data) => {
    return this.init().post(`/student/auth/student/add-course-count/${data}`);
  };

  addCourseToWishlist = (data) => {
    return this.init().post("/student/course/student/add-to-wishlist", data);
  };
  deleteCourseToWishlist = (data) => {
    console.log("dasijsiuheijvkdc", data);

    return this.init().delete(
      `/student/course/student/delete-from-wishlist?courseId=${data}`
    );
  };
  getReviews = (data) => {
    return this.init().get(`/student/auth/student/getcoursereviews/${data}`);
  };
  getUrl = (data) => {
    return this.init().post("/admin/get-url", data);
  };
  getVimeoStatus = (videoId) => {
    return this.init().get(`/student/vimeo-status/${videoId}`);
  };
  getQuiz = (data) => {
    return this.init().get(`/student/course/get-active-quiz/${data}`, data);
  };
  getSignature = (data) => {
    return this.init().post("/admin/course/get-signature", data);
  };
  getSubmittedQuizScore = (data) => {
    return this.init().get(`/student/course/quiz-result${data}`);
  };
  submitQuiz = (data) => {
    return this.init().post("/student/course/submit-quiz", data);
  };
  getLiveSession = (data) => {
    return this.init().get(`/student/get-live-session/${data}`);
  };
  getProgressDetails = (data) => {
    return this.init().get(`/student/progress/course/${data}`, data);
  };
  updateVideoCount = (data) => {
    return this.init().put("/student/course/add-course-progress", data);
  };
  getActiveAssignment = (data) => {
    return this.init().get(`/student/get-active-assignment/${data}`);
  };
  downloadAssignment = (data) => {
    return this.init().post("/student/download-assignment", data);
  };
  addCurrentVideo = (data) => {
    return this.init().put("/student/course/add-current-video", data);
  };
  submitAssignment = (data) => {
    return this.init().put("/student/submit-assignment", data);
  };
  reSubmitAssignment = (data) => {
    return this.init().put("/student/re-submit/assignment", data);
  };
  addComment = (data) => {
    return this.init().post("/student/add-comment", data);
  };
  addReview = ({ data, body }) => {
    return this.init().post(`/student/course/add-review/${data}`, body);
  };
  addLead = (data) => {
    return this.init().post("/student/create-lead", data);
  };
  getComment = (data) => {
    return this.init().get(data);
  };
  getSubmittedAssignment = (data) => {
    return this.init().get(`/student/assignment/get-submiited-Details/${data}`);
  };
  getCertificate = (id, studentId) => {
    return this.init().get(`/student/get-certificate/${id}/${studentId}`);
  };

  getImgBase64 = (data) => {
    return this.init().post(`/student/get-img-base64`, data);
  };

  //Payment
  proccedPayment = (data) => {
    return this.init().post("/student/order/student", data);
  };
  paymentStepTwo = (data) => {
    return this.init().post("/student/order/verifypayment", data);
  };

  createdFailedOrder = (data) => {
    return this.init().post("/student/order/create-failed-order", data);
  };

  getNotification = (data) => {
    return this.init().get(`/admin/get-unreadmessages/${data}`);
  };
  markAsRead = (data) => {
    return this.init().put(`/admin/mark-read-message/${data}`);
  };
  markAllAsReaded = (data) => {
    return this.init().put(`/admin/mark-all-as-read/${data}`);
  };
  getNotificationCount = () => {
    return this.init().get(`/admin/get-unread-count`);
  };
  getChatHistory = (data) => {
    return this.init().get(`/student/message-history?search=${data}`);
  };
  getChats = (data) => {
    console.log(data, "dataa");

    return this.init().get(`/student/get-message?recipientId=${data}`);
  };
  getActiveAdmins = () => {
    return this.init().get(`/student/get-recievers`);
  };
  addMessage = (data) => {
    return this.init().post(`/student/add-message`, data);
  };
  deleteAccount = () => {
    return this.init().delete("/student/delete-account");
  };

  getPaymentStatus = (data) => {
    console.log(data, "failed cid");

    return this.init().post(`/student/order/get-payment-review`, data);
  };


















// In your Api class - ensure these methods exist:
getStudentMessages = (recipientId = null) => {
  const query = recipientId ? `?recipientId=${recipientId}` : '';
  return this.init().get(`/student/messages${query}`);
};

sendStudentMessage = (data) => {
  return this.init().post("/student/send", data);
};

getStudentChatHistory = (search = "") => {
  return this.init().get(`/student/chat-history?search=${search}`);
};

getStudentAvailableUsers = () => {
  return this.init().get("/student/available-users");
};



// chat support

// Student Support Chat APIs
// getSupportChatHistory = (searchQuery = "") => {
//   const query = searchQuery ? `?search=${encodeURIComponent(searchQuery)}` : "";
//   return this.init().get(`/student/support-message-history${query}`);
// };

// getSupportChats = (recipientId) => {
//   console.log("🔄 Fetching STUDENT support chats for:", recipientId);
//   return this.init().get(`/student/support-get-message?recipientId=${recipientId}`);
// };

// getActiveAdminsForSupport = () => {
//   return this.init().get(`/student/support-get-active-admins`);
// };

// addSupportMessage = (data) => {
//   console.log("🔄 Sending STUDENT support message:", data);
//   return this.init().post(`/student/support-add-message`, data);
// };





  getSupportChatHistory = (searchQuery = "") => {
    const query = searchQuery ? `?search=${encodeURIComponent(searchQuery)}` : "";
    return this.init().get(`/student/support-message-history${query}`);
  };

  // Get Support Chats with admin
  getSupportChats = (recipientId) => {
    console.log("🔄 Fetching STUDENT support chats for:", recipientId);
    return this.init().get(`/student/support-get-message?recipientId=${recipientId}`);
  };

  // Get Active Admins for Support
  getActiveAdminsForSupport = () => {
    return this.init().get(`/student/support-get-active-admins`);
  };

  // Create Support Message (without recipientId for auto-assignment)
  addSupportMessage = (data) => {
    console.log("🔄 Sending STUDENT support message:", data);
    
    // For students, we don't send recipientId - backend will auto-assign
    const messageData = { ...data };
    if (messageData.recipientId === "support" || !messageData.recipientId) {
      delete messageData.recipientId;
    }
    
    return this.init().post(`/student/support-add-message`, messageData);
  };

  // NEW: Get assignment status for current student
  getStudentAssignmentStatus = () => {
    console.log("🔄 Getting student assignment status");
    return this.init().get(`/student/support-chat-assignment`);
  };

  // NEW: Get support ticket status
  getSupportTicketStatus = (ticketId) => {
    return this.init().get(`/student/support-ticket-status?ticketId=${ticketId}`);
  };

  // NEW: Create support ticket with details
  createSupportTicket = (data) => {
    console.log("🔄 Creating support ticket:", data);
    return this.init().post(`/student/support-create-ticket`, data);
  };

  // NEW: Rate support service
  rateSupportService = (data) => {
    console.log("🔄 Rating support service:", data);
    return this.init().post(`/student/support-rate-service`, data);
  };


  

  // In your Api class - ADD /student prefix
  getCustomCourseDetails = (slug) => {
    return this.init().get(
      `/student/course/custom-link/getcourse-by-slug/${slug}`
    );
  };

  // webinar

  getAllActiveWebinars = () => {
    return this.init().get("/student/get-all-active-webinars");
  };

  registerWebinar = (values) => {
    return this.init().post(
      `/student/register-webinar/${values?.courseId}`,
      values
    );
  };

  viewSingleWebinar = (id) => {
    return this.init().get(`/student/view-a-webinar-details/${id}`);
  };

  getAttendedWebinars = () => {
    return this.init().get(`/student/get-attended-webinars`);
  };

  //
  createCertifiacte = (data) => {
    return this.init().post(`/student/create/auto-generate-certificate`, data);
  };

  // verify captch token
  verifyCaptchaToken = (data) => {
    return this.init().post(`/student/verify-captcha`, data);
  };
}


const api = new Api();

export default api